module.exports = __webpack_public_path__ + "static/media/Web_cover_full_HD.89855d19.mp4";